import styled from '@emotion/styled';
import {fontSize, sizes} from 'patient-ping-remedy/packages/theme';

export const Wrapper = styled.button<{ concise?: boolean }>`
  font-size: ${({ concise }) => concise ? fontSize.standard : fontSize.displayMedium};
  padding: 0;
  margin-right: ${sizes.xSmall};
  margin-left: ${sizes.xxSmall};
  background: none;
  border: none;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
  }
`;
